// extracted by mini-css-extract-plugin
export default {"errorWrapper":"errorMessage_errorWrapper__0vpeZ","errorIcon":"errorMessage_errorIcon__UhZJ2"};